import * as React from 'react';
export const IcFemaleHygieneProducts = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.05 18a.91.91 0 01-1 1h-1a1 1 0 000 2h1a2.92 2.92 0 003-3 .91.91 0 011-1 2.54 2.54 0 001.27-.32L7.66 15a2.86 2.86 0 00-2.61 3zM20.62 3.58a.611.611 0 00-.07-.14 2.824 2.824 0 00-.2-.28 1.653 1.653 0 00-.12-.16l-.06-.06-.05-.06a1.558 1.558 0 00-.2-.16 1.919 1.919 0 00-.22-.18 1.613 1.613 0 00-.28-.17c-.08 0-.16-.09-.24-.12a1.918 1.918 0 00-.31-.11l-.25-.07h-.33L18 2h-.54c-.116.023-.23.056-.34.1a1.555 1.555 0 00-.23.06 2.378 2.378 0 00-.35.19l-.18.09a2.93 2.93 0 00-.48.39l-8.59 8.63a1 1 0 000 1.42l2.83 2.83a1.001 1.001 0 001.42 0L20 7.24l.12-.12a3 3 0 00.5-3.54z'
      fill='currentColor'
    />
  </svg>
);
